export const environment = {
    production: false,
    backendUrl: 'https://dev.rebate.fbusinesscenter.com/api',
    debug: true,
    keyCloakUrl:'https://qa-access-key-corp.falabella.tech/auth/',
    keyCloackRealm:'corp',
    sse: false,
    useCountryPrefix: true, //tiene que ir en true siempre para que vaya con el pais agregado a la url del backend
    version: '1.2.17',

    //version para correrlo en modo local
    // production: false,
    // backendUrl: 'http://localhost',
    // debug: true,
    // keyCloakUrl:'https://qa-access-key-corp.falabella.tech/auth/',
    // keyCloackRealm:'corp',
    // sse: false,
    // useCountryPrefix: false, //este va en false aca en local para que no mande el pais en la url
    // version: '1.2.15',
  };
